<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14DewqG/images/cover.jpg?1684306107944" alt="This image is the cover for the book An Occupation of Angels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Occupation of Angels
      </h1>
      <p class="bookDescription body article font2">
        <i>A British secret agent is caught in a plot to assassinate archangels who settled Earth after WWII in this classic thriller from the World Fantasy Award winning author!</i><br/><br/><b>“Sharp, brutal, cool--yet also stunningly imaginative and perfectly realised." —Michael Marshall, bestselling author of <i>The Straw Men</i> trilogy</b><br/><br/>In 1945, the Archangels materialised over the battlefields of Europe, ushering in a new Cold War. Fifty years later, they are being killed off… one by one.<br/><br/>But who – or what – can kill an angel?<br/><br/>Killarney is a shadow executive for the Bureau, British Intelligence’s most secret organisation. She is the best – and she always works alone. Sent on a desperate mission to locate a missing cryptographer who may prove the key to the murders, Killarney finds herself running for her life, from London to Paris to Moscow, leading to a confrontation with a very human evil in the frozen wastelands of Novosibirsk.<br/><br/>Plagued by dreams of a different world, and haunted by a swastika adorned with angel wings, it could take all of Killarney’s resources to survive, when Heaven itself may be threatened, and God herself may be walking the earth…<br/><br/>“Fast moving, powerfully phantasmagoric fantasy” – Adam Roberts<br/><br/>“A novella of blistering, ballistic energy and ferocious cleverness” – James Lovegrove<br/><br/>“A breathless adventure story, finely crafted and rammed home with the assured confidence of an author very much in his stride.” – <i>SFRevue.com</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lavie Tidhar
      </h2>
      
      <p class="authorDescription body article">Lavie Tidhar is author of <i>Osama</i>, <i>The Violent Century</i>, <i>A Man Lies Dreaming</i>, <i>Central Station</i>, <i>Unholy Land</i>, and <i>By Force Alone</i>. His latest novels are <i>The Hood</i> and <i>The Escapement</i>. His awards include the World Fantasy Award, the British Fantasy Award, the John W. Campbell Award, the Neukom Prize and the Jerwood Fiction Uncovered Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13aa41f8